import React from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import { getGoogleMapApiKey } from './../../../config/constant';

const libraries = ['places'];
const mapContainerStyle = {
  width: '94%',
  height: '600px',
};


const GMapComponent = (props) => {
    let center = {
        lat: props.lat,
        lng: props.lng
      };
  const entity_source = props?.entity_source;
  const gMapApiKey = getGoogleMapApiKey(entity_source);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: gMapApiKey,
    libraries,
  });

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading maps</div>;
  }
  return (
    <div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={10}
        center={center}
      >
        <Marker position={center} />
      </GoogleMap>
    </div>
  );
  // return (
  //   <div>
  //     Loading maps...
  //   </div>
  // );
};

export default GMapComponent;